import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export async function fetchSuperAdminCompanies() {
  const res = await fetch(`${API_BASE}/api/superadmin/ceos/companies`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الشركات'));
  const list = Array.isArray(data) ? data : [];
  return list.map((c) => ({ id: c.id, name: c.name }));
}

export async function fetchSuperAdminCeos({ page = 1, pageSize = 10, q = '' } = {}) {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('pageSize', String(pageSize));
  if (q && q.trim()) params.set('q', q.trim());
  const res = await fetch(`${API_BASE}/api/superadmin/ceos?${params.toString()}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الرؤساء التنفيذيين'));
  const list = Array.isArray(data.items) ? data.items : [];
  return {
    items: list.map((u) => ({
      id: u.id,
      userName: u.userName,
      fullName: u.fullName ?? '',
      email: u.email ?? '',
      phone: u.phone ?? '',
      isActive: !!u.isActive,
      companyId: u.companyId,
      companyName: u.companyName ?? '',
    })),
    page: Number(data.page) || 1,
    pageSize: Number(data.pageSize) || pageSize,
    total: Number(data.total) || 0,
    totalPages: Number(data.totalPages) || 0,
  };
}

export async function createSuperAdminCeo(payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/ceos`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة الرئيس التنفيذي'));
  return data;
}

export async function updateSuperAdminCeo(id, payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/ceos/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث الرئيس التنفيذي'));
  return data;
}
